<template>
  <div>
    <Header />

    <div id="appCapsule">

      <!-- HERO -->
      <section class="hero-section">

        <div class="hero-top">
          <div>
            <h4 class="text-white">قهرمان راننده 👋</h4>
            <p class="text-white">مدیریت بارهای خود را انجام دهید</p>
          </div>

          <div class="logo-box">
            <img src="assets/img/F2.png" alt="">
          </div>
        </div>

        <!-- STATUS -->
        <!-- <div class="status-box">
          <ion-icon name="information-circle"></ion-icon>
          <span>به پنل رانندگان خوش آمدید</span>
        </div> -->

      </section>

      <!-- MENUS -->
      <section class="menu-section">

        <div
          v-for="(listMenu, index) in listMenus"
          :key="index"
          class="menu-wrapper"
        >

          <span v-if="listMenu.status === 0" class="disabled-badge">
            غیر فعال
          </span>

          <div
            @click="handleMenuClick(listMenu)"
            class="menu-card"
            :class="{ disabled: listMenu.status === 0 }"
          >

            <div class="menu-icon">
              <img src="assets/svg/barlist.svg">
            </div>

            <div class="menu-content">
              <h5>{{ listMenu.title }}</h5>
              <p>مشاهده و ورود به بخش</p>
            </div>

            <ion-icon name="chevron-forward-outline"></ion-icon>

          </div>
        </div>

      </section>

      <!-- <Slider /> -->

    </div>
  </div>
</template>
<script>
// import Slider from '@/components/Slider.vue'
import Header from '@/components/HeaderHome.vue'
import router from '@/router'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'home',
  components: {
    // Slider,
    Header
  },
  data() {
    return {
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
      listMenus: [],
      status: 1,
    };
  },
  computed: {
    // نسخه‌ی major را از localStorage می‌خوانیم ("2.0.0" -> 2)
    appMajorVersion() {
      const raw = localStorage.getItem('version') || '0';
      return Number(raw.split('.')[0]) || 0;
    }
  },
  methods: {
    handleMenuClick(listMenu) {
      const major = this.appMajorVersion;

      if (listMenu.routeTo != 'nearLoads') {
        this.$router.push({ name: listMenu.routeTo });
        return;
      }

      // اگر غیرفعال بود
      if (listMenu.status === 0) {
        return;
      }

      // اگر فعال بود و نسخه major بزرگ‌تر مساوی 2 بود
      if (listMenu.status === 1 && major >= 2) {
        this.$router.push({ name: listMenu.routeTo });
        return;
      }

      // اگر فعال بود و نسخه major کمتر از 2 بود
      if (listMenu.status === 1 && major < 2) {
        this.checkVersion();
      }
    },
    nearLoads() {
      router.push({ name: 'nearLoads' })
    },
    searchProvince() {
      router.push({ name: 'selectCities' })
    },
    getListMenus() {
      const cachedData = localStorage.getItem("listMenus");
      const cachedTime = localStorage.getItem("listMenusTime");

      const eightHours = 8 * 60 * 60 * 1000;

      if (
        cachedData &&
        cachedTime &&
        Date.now() - Number(cachedTime) < eightHours
      ) {
        this.listMenus = JSON.parse(cachedData);
        return;
      }

      axios
        .get("https://xpanel.s-bar.ir/api/driver/listMenuDriver")
        .then((response) => {
          this.listMenus = response.data.data;

          localStorage.setItem(
            "listMenus",
            JSON.stringify(response.data.data)
          );
          localStorage.setItem(
            "listMenusTime",
            Date.now().toString()
          );
        });
    },
    tokenHandle() {
      // توکن را از localStorage می‌خوانیم نه از query، چون بعد از ریدایرکت query پاک می‌شود
      const fcmToken = this.$route.query.token || localStorage.getItem('token');

      // اگر توکنی نداریم اصلاً درخواست نفرست
      if (!fcmToken || fcmToken === 'no_token_available') {
        return;
      }

      axios.patch(`https://xpanel.s-bar.ir/api/driver/saveMyFireBaseToken`, {
        token: fcmToken
      }, this.axiosConfig)
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            Swal.fire({
              title: "راننده محترم!",
              text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
              icon: "error",
              confirmButtonColor: "#0099c9",
              confirmButtonText: "ورود مجدد!",
            }).then((result) => {
              if (result.isConfirmed) {                                                                                                                                                                                                     
                Object.keys(localStorage).forEach((key) => {
                  if (!['version'].includes(key)) {
                    localStorage.removeItem(key);
                  }
                });
                router.push({ name: 'login' })
              }
            });
          }
        });
    },
    checkVersion() {
      Swal.fire({
        title: '<h3 style="color:#1976d2;">🎉 نسخه جدید منتشر شد!</h3>',
        html: `
          <p style="font-size:15px; color:#444;">
            نسخه جدید برنامه آماده دانلود است.
          </p>

          <div style="display:flex; gap:10px; margin-top:15px; justify-content:center;">
              <button id="btn-bazar" 
                      style="flex:1; padding:10px; background:#43a047; color:white; border:none; border-radius:6px; cursor:pointer;">
                  بازار
              </button>

              <button id="btn-myket" 
                      style="flex:1; padding:10px; background:#0288d1; color:white; border:none; border-radius:6px; cursor:pointer;">
                  مایکت
              </button>
          </div>

          <button id="btn-later"
                  style="margin-top:10px; width:100%; height:35px; padding:5px 10px; background:#999; color:white; border:none; border-radius:6px; cursor:pointer;">
              بعداً
          </button>
        `,
        width: 350,
        showConfirmButton: false,
        showCancelButton: false,
        showDenyButton: false,
        background: '#f7f9fb',
        didOpen: () => {
          document.getElementById("btn-bazar").addEventListener("click", () => {
            localStorage.setItem("score", 1);
            window.open("https://cafebazaar.ir/app/com.sbar.driver");
            Swal.close();
          });

          document.getElementById("btn-myket").addEventListener("click", () => {
            localStorage.setItem("score", 1);
            window.open("https://myket.ir/app/com.sbar.driver");
            Swal.close();
          });

          document.getElementById("btn-later").addEventListener("click", () => {
            localStorage.setItem("score", 1);
            Swal.close();
          });
        }
      });
    }
  },
  mounted() {
    // پشتیبان: اگر version در query بود ذخیره‌اش کن (اصل کار در main.js انجام می‌شود)
    if (this.$route.query.version) {
      localStorage.setItem('version', this.$route.query.version);
    }

    // فقط وقتی نسخه قدیمی است هشدار بده، نه همیشه در اولین اجرا
    if (this.appMajorVersion < 2) {
      const hasShown = localStorage.getItem('versionChecked');
      if (!hasShown) {
        this.checkVersion();
        localStorage.setItem('versionChecked', 'true');
      }
    }

    localStorage.removeItem('scrollPosition');
    this.getListMenus();
    this.tokenHandle();
  },
}
</script>
<style scoped>



/* HERO */

.hero-section{
  background: linear-gradient(135deg, #cdd7f7, #32c6f4);
  padding:25px 18px 90px;
  border-radius:0 0 35px 35px;
  color:white;
}

.hero-top{
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.hero-top h4{
  margin:0;
  font-weight:800;
}

.hero-top p{
  margin-top:6px;
  opacity:.8;
  font-size:13px;
}

.logo-box{
  width:70px;
  height:70px;
  background:white;
  border-radius:18px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.logo-box img{
  width:55px;
}


/* MENU SECTION */

.menu-section{
  margin-top:-60px;
  padding:0 15px 25px;
}

/* CARD */

.menu-card{
  display:flex;
  align-items:center;
  gap:14px;

  background:white;
  border-radius:22px;
  padding:16px;
  margin-bottom:14px;

  box-shadow:0 8px 25px rgba(0,0,0,.06);

  transition:.25s;
}

.menu-card:active{
  transform:scale(.97);
}

.menu-content{
  flex:1;
}

.menu-content h5{
  margin:0;
  font-weight:700;
  font-size:15px;
}

.menu-content p{
  margin:4px 0 0;
  font-size:12px;
  color:#888;
}

/* ICON */

.menu-icon{
  width:55px;
  height:55px;
  border-radius:16px;
  background:#eef2ff;

  display:flex;
  align-items:center;
  justify-content:center;
}

.menu-icon img{
  width:28px;
}

/* DISABLED */

.disabled{
  opacity:.5;
  pointer-events:none;
}

.disabled-badge{
  position:absolute;
  top:-8px;
  left:5px;
  background:#999;
  color:white;
  font-size:11px;
  padding:2px 8px;
  border-radius:6px;
}

/* WRAPPER */

.menu-wrapper{
  position:relative;
}

</style>